/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useState } from "react";
import { Dialog, DialogActions, Button, DialogContent, DialogContentText, Slide } from "@material-ui/core";
import { ControlBarButton, Phone } from "amazon-chime-sdk-component-library-react";
import { MEETING_ACTIONS } from "../../../../../utility/constants";
import { useVideoMeetingEvents } from "../VideoMeetingEventProvider";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const EndMeetingControl = () => {
	const [showModal, setShowModal] = useState(false);
	const { setInMeetingContactId, sendMessage } = useVideoMeetingEvents();
	const toggleModal = () => setShowModal(!showModal);

	const endMeetingForAll = async () => {
		setInMeetingContactId("");
		await sendMessage(MEETING_ACTIONS.AGENT_ENDED);
		toggleModal();
	};

	return (
		<>
			<ControlBarButton
				className="control-button control-button-end"
				icon={<Phone />}
				onClick={toggleModal}
				label="Leave"
			/>
			{showModal && (
				<Dialog
					open={showModal}
					onClose={toggleModal}
					TransitionComponent={Transition}
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogContent style={{ minWidth: 400 }}>
						<DialogContentText id="alert-dialog-slide-description" style={{ color: "black" }}>
							Please confirm to end current meeting
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button variant={"outlined"} onClick={toggleModal}>
							Resume
						</Button>
						<Button variant={"outlined"} onClick={endMeetingForAll}>
							End meeting
						</Button>
					</DialogActions>
				</Dialog>
			)}
		</>
	);
};

export default EndMeetingControl;
